/**
 * Module constants - Single source of truth for all module-related options
 * Use object properties for readable access (e.g., TITLE_SIZE_OPTIONS.LARGE)
 * Arrays for Storybook are generated programmatically to avoid duplication
 */

/** ------------ Lockup ------------ */

/** Container layout options */
export const CONTAINER_OPTIONS = {
  CONTAINED: 'contained',
  UNCONTAINED: 'uncontained',
} as const;

/** Module fill type options for background styling */
export const MODULE_FILL_TYPE_OPTIONS = {
  BASE: 'base',
  RAISED: 'raised',
  NO_FILL: 'no-fill',
  GRADIENT: 'gradient',
  IMAGE: 'image',
} as const;

/** Gradient options for background styling */
export const GRADIENT_OPTIONS = {
  GLOW_ORANGE: 'glow-orange',
  PINK_ORANGE: 'pink-orange',
  GLOW_NEON: 'glow-neon',
  GLOW_PINK: 'glow-pink',
  NEON_PINK: 'neon-pink',
  PINK_BLUE: 'pink-blue',
  GLOW_BLUE: 'glow-blue',
  GLOW_SNAP_PEA: 'glow-snap-pea',
} as const;

/** Module flow direction options */
export const MODULE_FLOW_DIRECTION_OPTIONS = {
  COLUMN: 'column',
  ROW: 'row',
} as const;

/** Content layout direction options */
export const CONTENT_LAYOUT_OPTIONS = {
  CONTENT_TRAILING: 'content-trailing',
  CONTENT_LEADING: 'content-leading',
} as const;

/** ------------ Header ------------ */

/** HTML heading element options for titleType */
export const TITLE_TYPE_OPTIONS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
} as const;

/** Title size options */
export const TITLE_SIZE_OPTIONS = {
  SMALL: 'small',
  LARGE: 'large',
} as const;

/** Heading alignment options */
export const HEADING_ALIGNMENT_OPTIONS = {
  START: 'start',
  CENTER: 'center',
} as const;

/** CTA type options */
export const CTA_TYPE_OPTIONS = {
  INLINE: 'inline',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

/** ------------ Content ------------ */

/** Image aspect ratio options */
export const IMAGE_ASPECT_RATIO_OPTIONS = {
  SQUARE: 'square',
  LANDSCAPE: 'landscape',
  STANDARD: 'standard',
} as const;

/** Card orientation options */
export const CARD_ORIENTATION_OPTIONS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
} as const;

/** Card fill type options */
export const CARD_FILL_TYPE_OPTIONS = {
  BASE: 'base',
  RAISED: 'raised',
  UNCONTAINED: 'uncontained',
} as const;

/** Card group layout options */
export const CARD_GROUP_LAYOUT_OPTIONS = {
  GRID: 'grid',
  INLINE: 'inline',
} as const;

/** ------------ Breadcrumbs ------------ */
/** Breadcrumbs alignment options */
export const BREADCRUMBS_ALIGNMENT_OPTIONS = {
  LEFT: 'left',
  CENTER: 'center',
} as const;

/** Breadcrumbs Density options */
export const BREADCRUMBS_DENSITY_OPTIONS = {
  DEFAULT: 'default',
  COMPACT: 'compact',
  NO_PADDING: 'no-padding',
} as const;

/** Breadcrumbs position options */
export const BREADCRUMBS_POSITION_OPTIONS = {
  PAGE_TOP: 'page-top',
  PAGE_BOTTOM: 'page-bottom',
} as const;
